import { call, put, takeLatest, } from 'redux-saga/effects';
import { Urls } from 'src/common/urls';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { getErrorFromResponse } from 'src/features/Security/networking/util';
import { CashboxStmtRecordsFilters } from 'src/common/models/cashboxStatement';
import { ServiceContractPaymentRecordsFilters } from 'src/common/models/serviceContractDebitPayment';

function* createContractPaymentApi(action: Actions.CreateContractPaymentAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.SERVICE_CONTRACT_DEBIT_PAYMENT.CREATE, action.contractPayment)
        yield put(Actions.createContractPaymentApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.createContractPaymentApiError(getErrorFromResponse(err)));
    }
}

const buildCashboxStmtQueryString = (filters?: CashboxStmtRecordsFilters) => {
    const filtersList: string[] = []
    if (filters?.dateFrom) {
        filtersList.push(`dateFrom=${filters.dateFrom}`)
    }
    if (filters?.dateTo) {
        filtersList.push(`dateTo=${filters.dateTo}`)
    }
    if (filters?.filter) {
        filtersList.push(`filter=${filters.filter}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getCashboxStmtRecordsApi(action: Actions.GetCashboxStmtRecordsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.CASHBOX_STATEMENT.GET_RECORDS(buildCashboxStmtQueryString(action.filters)))
        yield put(Actions.getCashboxStmtRecordsApiSuccess(
            response.data.results,
            response?.data?.balance || [],
        ))
    } catch (err) {
        yield put(Actions.getCashboxStmtRecordsApiError(getErrorFromResponse(err)));
    }
}

const buildContractPaymentsQueryString = (filters?: ServiceContractPaymentRecordsFilters) => {
    const filtersList: string[] = []
    if (filters?.dateFrom) {
        filtersList.push(`dateFrom=${filters.dateFrom}`)
    }
    if (filters?.dateTo) {
        filtersList.push(`dateTo=${filters.dateTo}`)
    }
    if (filters?.customerId) {
        filtersList.push(`customerId=${filters.customerId}`)
    }
    if (filters?.serviceContractId) {
        filtersList.push(`serviceContractId=${filters.serviceContractId}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getContractPaymentRecordsApi(action: Actions.GetContractPaymentRecordsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.SERVICE_CONTRACT_DEBIT_PAYMENT.GET_RECORDS(buildContractPaymentsQueryString(action.filters)))
        yield put(Actions.getContractPaymentRecordsApiSuccess(
            response.data
        ))
    } catch (err) {
        yield put(Actions.getContractPaymentRecordsApiError(getErrorFromResponse(err)));
    }
}

function* sendContractPaymentReceiptApi(action: Actions.SendPaymentContractReceiptAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.SERVICE_CONTRACT_DEBIT_PAYMENT.SEND_PAYMENT_RECEIPT, {
            paymentRecordIds: action.paymentRecordIds,
        })
        yield put(Actions.sendPaymentContractReceiptApiSuccess(
            response.data
        ))
    } catch (err) {
        yield put(Actions.sendPaymentContractReceiptApiError(getErrorFromResponse(err)));
    }
}

export default function* contractDebitPaymentSagas() {
    yield takeLatest(ActionTypes.CREATE_CONTRACT_PAYMENT_API, createContractPaymentApi)
    yield takeLatest(ActionTypes.GET_CASHBOX_STATEMENT_RECORDS_API, getCashboxStmtRecordsApi)
    yield takeLatest(ActionTypes.GET_CONTRACT_PAYMENT_RECORDS_API, getContractPaymentRecordsApi)
    yield takeLatest(ActionTypes.SEND_CONTRACT_PAYMENT_RECEIPT_API, sendContractPaymentReceiptApi)
}